import React, { Fragment, useState } from 'react';
import { Typography, Timeline, Button } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { CUSTOMER_ACTIONS, PAGES } from '../constants';
import AppleGoogleButtons from './Styled/AppleGoogleButtons';
import { useInject } from '../common';
import { useCustomer, useCustomerDispatch } from '../common/customerContext';
import useCustomerNavigation from '../Hooks/NavigationHook';

const { Title, Paragraph, Text } = Typography;

const DigsNoCCPlanWelcome = () => {
  const customer = useCustomer();
  const dispatch = useCustomerDispatch();
  const customerNavigation = useCustomerNavigation();
  const [confirmed, setConfirmed] = useState(
    customer.status == CUSTOMER_ACTIONS.COMPLETE && customer.cartId
  );
  const [loading, setloading] = useState(false);
  const { selfSignupCustomerService, communicationService } = useInject();
  const saveConfirmation = async () => {
    setloading(true);
    const updatedCustomer =
      await selfSignupCustomerService.saveCustomerProgress(customer);
    const result = await selfSignupCustomerService.completeCustomerProgress(
      customer
    );
    dispatch(CUSTOMER_ACTIONS.COMPLETE, updatedCustomer);
    await communicationService.sendPerServiceWelcomeEmail(customer);

    setConfirmed(true);
    setloading(false);
  };

  return (
    <Fragment>
      <div>
        <Typography>
          <Title level={2} style={{ textAlign: 'center' }}>
            {confirmed ? 'Thanks! Your Digs Plan is Active' : 'Confirmation'}
          </Title>
          {confirmed ? (
            <Paragraph>
              We're thrilled to welcome you to the Digs family!
            </Paragraph>
          ) : (
            <Paragraph>
              We're thrilled to welcome you to the Digs family! Click below to
              sign up for Digs. No credit is required to sign up and you can
              cancel any time.
            </Paragraph>
          )}

          <Title level={2} style={{ textAlign: 'center' }}>
            {!confirmed && (
              <Fragment>
                <Button
                  className="main-button"
                  type="primary"
                  loading={loading}
                  onClick={() => customerNavigation(PAGES.SCHEDULE)}
                >
                  {confirmed ? 'WELCOME!' : 'YES, SIGN ME UP FOR DIGS'}
                </Button>
                <br />
                <span style={{ fontSize: 12, fontWeight: 'normal' }}>
                  No credit card required to sign up. Cancel any time.
                </span>
              </Fragment>
            )}
          </Title>

          <Title level={3}>What Happens Next</Title>
          <Timeline
            style={{ marginBottom: 0 }}
            items={[
              {
                children: (
                  <>
                    <Text strong>Your Digs team will reach out to you</Text>
                    <Paragraph>
                      Within <Text strong>2 business days</Text>, our team will
                      reach out to you to review your services, plan out your
                      maintenance calendar AND begin scheduling your first
                      service!
                    </Paragraph>
                  </>
                ),
                dot: (
                  <CalendarOutlined
                    style={{
                      fontSize: '16px',
                      color: 'green',
                      backgroundColor: 'transparent',
                    }}
                  />
                ),
                color: 'blue',
              },
            ]}
          />

          <Title level={3} style={{ marginTop: -24 }}>
            Install the Digs App
          </Title>
          <Paragraph>
            Make the most of your Digs Plan by downloading the Digs app! Through
            the app, you'll be able to:
          </Paragraph>
          <ul>
            <li>View your plan details</li>
            <li>Access your maintenance calendar</li>
            <li>Receive updates and more</li>
          </ul>
        </Typography>
        <AppleGoogleButtons />
      </div>
    </Fragment>
  );
};

export default DigsNoCCPlanWelcome;
